/**
 * Personalisierer — Mobil- und Lesbarkeits-Korrekturen
 * ──────────────────────────────────────────────────
 * canvArt studios · 22.09.2026
 *
 * WARUM DIESE DATEI EXISTIERT
 * ---------------------------
 * Beim Durchlaufen des mobilen Kaufpfads am 22.09.2026 kamen drei Dinge
 * heraus, die den Editor praktisch unbrauchbar machten:
 *
 *  1) Der Finisher-Block landete schwarz (#111111) und klein mitten auf
 *     dem Motiv. Da nahezu alle Lauf- und Sportmotive dunkle Fotos sind,
 *     war der Text nach dem Klick auf "Daten aufs Motiv setzen" faktisch
 *     unsichtbar. Der Kunde musste vier Regler bedienen, um ueberhaupt
 *     etwas zu sehen — auf dem Handy in einem Modal, das dafuer gescrollt
 *     werden muss.
 *
 *  2) Derselbe Effekt beim freien Text ("Text hinzufuegen", fill #000000).
 *
 *  3) Der Hinweistext im Editor sprach Desktop: "Klicke ein Element an ->
 *     ziehe die Ecken ...". Auf einem Telefon gibt es weder Klick noch Maus.
 *
 * WIE ES GELOEST IST
 * ------------------
 * Statt einer neuen festen Farbe wird die Helligkeit des Motivs an genau
 * der Stelle gemessen, an der der Text steht, und daraus Schwarz oder
 * Weiss gewaehlt — plus ein weicher Schatten, damit der Text auch auf
 * unruhigen Fotos steht. Gehaengt wird das an fabric.Canvas.prototype.add,
 * damit assets/product-personalizer.js unangetastet bleibt.
 *
 * Schlaegt die Messung fehl (z.B. weil das Motiv wegen CORS nicht
 * ausgelesen werden darf), wird Weiss genommen: die grosse Mehrheit der
 * Motive ist dunkel.
 *
 * Eingebunden aus snippets/ppz-finisher-panel.liquid.
 */

(function () {
  'use strict';

  var FALLBACK_FILL = '#FFFFFF';
  var LUMA_SWITCH = 140; // darueber gilt der Untergrund als hell

  /* ───────── Helligkeit unter einem Objekt messen ───────── */

  function averageLuminance(canvas, rect) {
    var img = document.querySelector('[data-ppz-mockup]');
    if (!img || !img.naturalWidth || !img.naturalHeight) return null;

    try {
      var SAMPLE = 48;
      var off = document.createElement('canvas');
      off.width = SAMPLE;
      off.height = SAMPLE;
      var ctx = off.getContext('2d', { willReadFrequently: true });

      var cw = canvas.getWidth();
      var ch = canvas.getHeight();
      if (!cw || !ch) return null;

      // Das Motiv liegt mit object-fit:cover hinter dem Canvas.
      // Dieselbe Cover-Rechnung nachbauen, sonst misst man die
      // falsche Stelle.
      var stageRatio = cw / ch;
      var imgRatio = img.naturalWidth / img.naturalHeight;
      var sw = img.naturalWidth;
      var sh = img.naturalHeight;
      if (imgRatio > stageRatio) {
        sw = img.naturalHeight * stageRatio;
      } else {
        sh = img.naturalWidth / stageRatio;
      }
      var baseX = (img.naturalWidth - sw) / 2;
      var baseY = (img.naturalHeight - sh) / 2;

      var relX = Math.max(0, Math.min(1, rect.left / cw));
      var relY = Math.max(0, Math.min(1, rect.top / ch));
      var relW = Math.max(0.02, Math.min(1 - relX, rect.width / cw));
      var relH = Math.max(0.02, Math.min(1 - relY, rect.height / ch));

      ctx.drawImage(
        img,
        baseX + sw * relX,
        baseY + sh * relY,
        sw * relW,
        sh * relH,
        0,
        0,
        SAMPLE,
        SAMPLE
      );

      var data = ctx.getImageData(0, 0, SAMPLE, SAMPLE).data;
      var sum = 0;
      for (var i = 0; i < data.length; i += 4) {
        sum += 0.2126 * data[i] + 0.7152 * data[i + 1] + 0.0722 * data[i + 2];
      }
      return sum / (data.length / 4);
    } catch (e) {
      return null;
    }
  }

  function pickFill(canvas, rect) {
    var luma = averageLuminance(canvas, rect);
    if (luma === null) return FALLBACK_FILL;
    return luma > LUMA_SWITCH ? '#111111' : '#FFFFFF';
  }

  function shadowFor(fill) {
    return new window.fabric.Shadow({
      color: fill === '#FFFFFF' ? 'rgba(0,0,0,0.55)' : 'rgba(255,255,255,0.6)',
      blur: 18,
      offsetX: 0,
      offsetY: 2
    });
  }

  /* ───────── Eingriff beim Hinzufuegen eines Objekts ───────── */

  function patchFabric() {
    var fabric = window.fabric;
    if (!fabric || !fabric.Canvas) return false;
    if (fabric.Canvas.prototype.__ppzContrastPatched) return true;

    var originalAdd = fabric.Canvas.prototype.add;

    fabric.Canvas.prototype.add = function () {
      var canvas = this;
      var args = Array.prototype.slice.call(arguments);

      args.forEach(function (obj) {
        if (!obj || typeof obj.set !== 'function') return;
        var isFinisher = obj._ppzFinisher === true;
        var isFreeText = obj.type === 'i-text' || obj.type === 'text';
        if (!isFinisher && !isFreeText) return;

        // Nur eingreifen, wenn der Personalisierer seine alten
        // Startfarben gesetzt hat. Was der Kunde selbst waehlt,
        // bleibt unangetastet.
        var f = (obj.fill || '').toString().toLowerCase();
        if (f !== '#111111' && f !== '#000000') return;

        try {
          if (isFinisher) {
            // Der Block war mit area.w * 0.042 bemessen und auf dem
            // Handy kaum zu entziffern.
            var bumped = Math.max(18, Math.round((obj.fontSize || 20) * 1.31));
            obj.set({ fontSize: bumped, fontWeight: '700' });
          }

          var rect = obj.getBoundingRect(true, true);
          var fill = pickFill(canvas, rect);
          obj.set({ fill: fill, shadow: shadowFor(fill) });
        } catch (e) {
          obj.set({ fill: FALLBACK_FILL });
        }
      });

      return originalAdd.apply(this, arguments);
    };

    fabric.Canvas.prototype.__ppzContrastPatched = true;
    return true;
  }

  // fabric.js wird mit defer geladen — kurz pollen statt raten.
  (function waitForFabric(start) {
    start = start || Date.now();
    if (patchFabric()) return;
    if (Date.now() - start > 12000) return;
    setTimeout(function () {
      waitForFabric(start);
    }, 60);
  })();

  /* ───────── Texte: Touch statt Maus ───────── */

  function fixCopy() {
    var hint = document.querySelector('.ppz-hint');
    if (hint && !hint.hasAttribute('data-ppz-selection-hint') && !hint.dataset.ppzTouchCopy) {
      var svg = hint.querySelector('svg');
      hint.textContent = '';
      if (svg) hint.appendChild(svg);
      hint.insertAdjacentHTML(
        'beforeend',
        ' Element antippen, dann mit dem Finger <strong>verschieben</strong>. ' +
          'An den Eckpunkten <strong>größer ziehen</strong>, am Punkt darüber ' +
          '<strong>drehen</strong>.'
      );
      hint.dataset.ppzTouchCopy = '1';
    }

    // Unter dem Trigger-Button fehlte jede Erklaerung, wofuer er gut ist.
    var wrapper = document.querySelector('.ppz-wrapper');
    if (wrapper && !wrapper.querySelector('.ppz-trigger-hint')) {
      var btn = wrapper.querySelector('[data-ppz-open]');
      if (btn) {
        var p = document.createElement('p');
        p.className = 'ppz-trigger-hint';
        p.textContent =
          'Veranstaltung, Distanz, Zielzeit und Datum aufs Motiv — Druckvorschau vor dem Kauf.';
        btn.insertAdjacentElement('afterend', p);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixCopy);
  } else {
    fixCopy();
  }
})();

